import {useMemo} from 'react';
import {GoogleMap, Marker, LoadScript} from '@react-google-maps/api';
import Card from 'legacy/components/elements/card';
import Typography from 'legacy/components/elements/typography';
import SensorSearchBar from 'legacy/components/sensorSearchBar';
import {demoMapStyles} from 'legacy/constants';
import Sensors from './sensors';
import {ISensorSimple} from 'legacy/model/waterStation';
import {useProfileState} from 'providers/profileStateProvider';
import {useDashboardHomeState} from 'providers/dashboardHomeStateProvider';
import {ICenter} from 'models/center';

const SensorMap = ({className}: {className?: string}) => {
  const {centers} = useProfileState();
  const {selectedCenterId} = useDashboardHomeState();

  const sensorList: ISensorSimple[] = [];

  const createPosition = (center: ICenter) => {
    return {
      lat: Number(center.location.latitude),
      lng: Number(center.location.longitude),
    };
  };

  const mapCenterPosition = useMemo(() => {
    if (centers.length === 0) {
      return {lat: 0, lng: 0};
    }

    let center = centers.find((center) => center.id === selectedCenterId);

    if (!center) {
      center = centers[0];
    }

    return createPosition(center);
  }, [centers, selectedCenterId]);

  return (
    <Card
      className={`map-card sensor-list ${
        className ? className : 'small-card-last'
      }`}
    >
      <div className={'card-header'}>
        <div className={'card-header-section1'}>
          <Typography
            size={'sub'}
            className="text-normal-blue uppercase font-bold whitespace-nowrap"
          >
            MAP
          </Typography>

          <SensorSearchBar
            style={{zIndex: 1}}
            sensorList={sensorList}
            inputStyle={{height: 48, maxHeight: 48, maxWidth: 400}}
            placeholder="Search"
            onChange={() => {}}
          />
        </div>
      </div>
      <div>
        <LoadScript
          id="d97044c47eef0032"
          googleMapsApiKey={`${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`}
          language="en"
          region="EN"
          version="weekly"
        >
          <GoogleMap
            id="d97044c47eef0032"
            mapContainerStyle={{
              height: '400px',
              width: '100%',
              borderRadius: '10px',
              border: '1px solid #C0C0C1',
            }}
            zoom={3.5}
            center={mapCenterPosition}
            options={{styles: demoMapStyles}}
          >
            {centers.map((center, index: number) => {
              if (center.id === selectedCenterId) {
                return (
                  <Marker
                    key={index}
                    icon={{
                      path: 'M 15.272,31.458c 0.168,0.186, 0.33,0.306, 0.486,0.39c 0.002,0.002, 0.006,0.002, 0.008,0.004 c 0.108,0.056, 0.214,0.098, 0.314,0.098c 0.1,0, 0.206-0.042, 0.314-0.098c 0.002-0.002, 0.006-0.002, 0.008-0.004 c 0.156-0.084, 0.318-0.204, 0.486-0.39c0,0, 9.296-10.11, 10.23-18.87c 0.056-0.452, 0.094-0.91, 0.094-1.376C 27.212,5.020, 22.192,0, 16,0 S 4.788,5.020, 4.788,11.212c0,0.474, 0.038,0.936, 0.096,1.394C 5.842,21.362, 15.272,31.458, 15.272,31.458z M 16,4 c 3.976,0, 7.212,3.236, 7.212,7.212c0,3.976-3.236,7.212-7.212,7.212S 8.788,15.188, 8.788,11.212C 8.788,7.236, 12.024,4, 16,4z',
                      fillColor: '#0d3d5e',
                      fillOpacity: 0.9,
                      scale: 1,
                      strokeColor: '#0d3d5e',
                      strokeWeight: 1,
                    }}
                    zIndex={5}
                    onClick={() => {}}
                    title="active"
                    position={createPosition(center)}
                  />
                );
              }
              return (
                <Marker
                  key={index}
                  position={createPosition(center)}
                  onClick={() => {}}
                  icon={{
                    path: 'M 15.272,31.458c 0.168,0.186, 0.33,0.306, 0.486,0.39c 0.002,0.002, 0.006,0.002, 0.008,0.004 c 0.108,0.056, 0.214,0.098, 0.314,0.098c 0.1,0, 0.206-0.042, 0.314-0.098c 0.002-0.002, 0.006-0.002, 0.008-0.004 c 0.156-0.084, 0.318-0.204, 0.486-0.39c0,0, 9.296-10.11, 10.23-18.87c 0.056-0.452, 0.094-0.91, 0.094-1.376C 27.212,5.020, 22.192,0, 16,0 S 4.788,5.020, 4.788,11.212c0,0.474, 0.038,0.936, 0.096,1.394C 5.842,21.362, 15.272,31.458, 15.272,31.458z M 16,4 c 3.976,0, 7.212,3.236, 7.212,7.212c0,3.976-3.236,7.212-7.212,7.212S 8.788,15.188, 8.788,11.212C 8.788,7.236, 12.024,4, 16,4z',
                    fillColor: '#B2B2B2',
                    fillOpacity: 1,
                    scale: 0.7,
                    strokeWeight: 1,
                  }}
                />
              );
            })}
          </GoogleMap>
        </LoadScript>
        <Sensors centers={centers} />
      </div>
    </Card>
  );
};

export default SensorMap;
